module.exports = __webpack_public_path__ + "media/images/emblems/Adelboden-coat_of_arms-ebc5ce9e98c2c63f1428f641f3738f93.svg";